import moment from "moment"
import translations from "translations"
import * as I18n from "services/i18n"

export function handleFormValidations() {
  $(document).on('click', '#company_reports_form .btn-search', function(event) {
    const reportType = $('#js-company-reports-report-type-select');

    if (reportType.val() == '') {
      preventDefaultAndScrollTop(event)

      $('.report-type-error').text(I18n.t(translations(), 'reports.excel_analytics.form.errors.invalid_empty_field')).show()
    } else {
      $('.report-type-error').hide();
    }

    // No modo integral (seleção de empresas gera obras acima do threshold) o
    // seletor de obras fica escondido e o relatório sai com todas as obras das
    // empresas selecionadas — então não exigimos seleção de obra.
    const integralMode = $('#company_reports_form').attr('data-obras-integral') === 'true';

    if (integralMode) {
      $('.obras-error').hide();
    } else {
      const obrasMultiEmpresa = $('.empresa-obras-multiselect');
      const obras = obrasMultiEmpresa.length ? obrasMultiEmpresa : $('.construction-multiselect');
      const obrasValues = (obras.val() || []).filter(function (v) {
        return String(v).indexOf('empresa-') !== 0;
      });

      if (obrasValues.length === 0) {
          preventDefaultAndScrollTop(event)

          $('.obras-error').text(I18n.t(translations(), 'reports.excel_analytics.form.errors.invalid_empty_field')).show()
      } else {
          $('.obras-error').hide();
      }
    }

  })
}

function preventDefaultAndScrollTop(event) {
  $("html, body").animate({ scrollTop: 0 });
  event.preventDefault()
}
